export default {
  perfectMoney: {
    title: "برای ادامه بر روی گزینه مورد نظر کلیک کنید:",
    buyButton: "خرید",
    sellButton: "فروش",
    notVerified: {
      title: "شما احراز هویت نکرده‌اید",
      subtitle: "جهت خرید و فروش پرفکت‌مانی، احراز هویت خود را تکمیل کنید",
      verificationButton: "تکمیل احراز هویت"
    },
    buyPage: {
      title: 'شما در حال "خرید" {n} هستید.',
      availableBalance: "موجودی قابل برداشت:",
      payment: "پرداخت می‌کنید",
      noResults: "نتیجه‌ای یافت نشد.",
      noData: "نتیجه‌ای یافت نشد.",
      received: "دریافت می‌کنید(تقریبا)",
      pmLabel: "آدرس پرفکت‌مانی",
      rules: {
        part1: "ضمن انجام این سفارش تایید میکنم",
        linkTitle: "قوانین سایت اکسکوینو",
        part2: "را مطالعه کرده و می پذیرم."
      },
      submitButton: "ادامه فرآیند {n}",
      balanceNotEnough: "موجودی کیف پول شما کافی نیست.",
      maxReceive: "حداکثر مقدار دریافتی {amount} است.",
      minReceive: "انتقال مقدار دریافتی {amount} است."
    },
    sellPage: {
      title: 'شما در حال "فروش" {n} هستید.',
      payment: "پرداخت می‌کنید",
      noResults: "نتیجه‌ای یافت نشد.",
      noData: "نتیجه‌ای یافت نشد.",
      received: "دریافت می‌کنید(تقریبا)",
      rules: {
        part1: "ضمن انجام این سفارش تایید میکنم",
        linkTitle: "قوانین سایت اکسکوینو",
        part2: "را مطالعه کرده و می پذیرم."
      },
      submitButton: "ادامه فرآیند {n}",
      evCode: "کد ووچر",
      evNumber: "شماره ووچر"
    },
    orderProcess: {
      cancelButton: "لغو سفارش",
      buy: {
        expireTitle: "مهلت شما برای تکمیل این سفارش به پایان رسید.",
        payment: "پرداختی",
        netReceived: "خالص دریافتی",
        fee: "کارمزد:",
        addressTitle: "آدرس",
        submitButton: "ادامه فرآیند خرید",
        receivedCodeLabel: "کد پیامک شده",
        resendCodeTitle: "ارسال مجدد کد تا { n } ثانیه دیگر",
        resendCodeButton: "دریافت مجدد کد تایید",
        verifyOtpButton: "تایید و ثبت نهایی",
        successOrder: {
          title: "درخواست خرید شما با موفقیت ثبت شد",
          subtitle: "بعد از تایید توسط اکسکوینو، سفارش شما تکمیل خواهد شد.",
          payment: "پرداختی",
          netReceived: "خالص دریافتی",
          transactionNumber: "شماره تراکنش:",
          fee: "کارمزد:",
          addressTitle: "آدرس",
          submitDate: "تاریخ و زمان ثبت:",
          transactionHistoryHistoryButton: "مشاهده وضعیت تراکنش‌ها",
          dashboardButton: "رفتن به داشبورد"
        }
      },
      sell: {
        expireTitle: "مهلت شما برای تکمیل این سفارش به پایان رسید.",
        payment: "پرداختی",
        netReceived: "خالص دریافتی",
        fee: "کارمزد:",
        submitButton: "ادامه فرآیند فروش",
        perfectMoneyHint:
          "برای اتصال به درگاه پرداخت پرفکت‌مانی حتما از آیپی غیر از ایران استفاده نمایید.",
        successOrder: {
          title: "درخواست خرید شما با موفقیت ثبت شد",
          payment: "پرداختی",
          netReceived: "خالص دریافتی",
          transactionNumber: "شماره تراکنش:",
          fee: "کارمزد:",
          changeFee: "کارمزد تبدیل:",
          submitDate: "تاریخ و زمان ثبت:",
          transactionHistoryHistoryButton: "مشاهده وضعیت تراکنش‌ها",
          dashboardButton: "رفتن به داشبورد"
        }
      }
    },
    reSubmitSell: {
      title: "تراکنش ناموفق",
      payment: "پرداختی",
      netReceived: "خالص دریافتی",
      transactionNumber: "شماره تراکنش:",
      paymentPrice: "مبلغ پرداختی:",
      submitDate: "تاریخ و زمان ثبت:",
      transactionHistoryHistoryButton: "مشاهده وضعیت تراکنش‌ها",
      dashboardButton: "رفتن به داشبورد",
      repeatOrderButton: "انجام مجدد سفارش"
    }
  }
};
